import { CustomClassNamesInterface } from '../types/MiscellaneousTypes';

export const stepTypes = {
  AUTHENTICATION_STEP: 'AUTHENTICATION_STEP',
  EMBEDDED_SUCCESS_FORM: 'EMBEDDED_SUCCESS_FORM',
  EMBEDDED_SUCCESS_PAGE: 'EMBEDDED_SUCCESS_PAGE',
  CUSTOM_SUCCESS_PAGE: 'CUSTOM_SUCCESS_PAGE',
  EMBEDDED_SUCCESS_PAGE_WITHOUT_SLOTS: 'EMBEDDED_SUCCESS_PAGE_WITHOUT_SLOTS',
  WEBINAR_CTA_SUCCESS_PAGE: 'WEBINAR_CTA_SUCCESS_PAGE'
};

export const progressBarType = {
  stepProgressBar: 'STEP_PROGRESS_BAR',
  numberedStepProgressBar: 'NUMBERED_STEP_PROGRESS_BAR'
};

export const defaultCustomFormClassNames: CustomClassNamesInterface = {
  nextAndSubmitButton: 'nextAndSubmitButton',
  publicRegistrationFormContainer: 'publicRegistrationFormContainer',
  publicRegistrationFormFooterBtnWrapper:
    'publicRegistrationFormBottomBtnWrapper',
  informedRadioFieldOption: 'informedRadioFieldOption',
  informedRadioFieldButton: 'informedRadioFieldButton',
  informedRadioGroupField: 'informedRadioGroupField',
  verifyOtpAndNextButton: 'verifyOtpAndNextButton',
  multiStepGoBackBtn: 'multiStepGoBackBtn',
  checkboxGroupFieldLabelClassName: 'checkboxGroupFieldLabel',
  checkboxGroupItemLabelClassName: 'checkboxGroupItemLabel'
};

export const EXCLUSIVE_EBOOK_IMAGE_URL =
  'https://d14qv6cm1t62pm.cloudfront.net/sso/webinars/iitians-webinar/exclusive-academy-freebie.png';

export const SUCCESS_MESSAGE_BG_IMAGE_URL =
  'https://d14qv6cm1t62pm.cloudfront.net/sso/webinars/iitians-webinar/success-message-bg-image.jpg';

export const GOOGLE_CALENDAR_EVENT_TITLE =
  'Nxtwave live session Reminder: Land a High Paid Job!';
export const GOOGLE_CALENDAR_EVENT_DETAILS = `📅 Your first step to a HIGH PAID TECH CAREER!

Join an IITians-led live session where you’ll learn how build in-demand skills like AI, ML, Web Development, Data Science & more 😎

🚨Get a roadmap to land high paying tech jobs in top companies ⚡️ Don't miss out!
 
Joining link will be shared on your WhatsApp 📲`;
